import { render, staticRenderFns } from "./Framevastgoed.vue?vue&type=template&id=4d1f0d00&scoped=true&"
import script from "./Framevastgoed.vue?vue&type=script&lang=js&"
export * from "./Framevastgoed.vue?vue&type=script&lang=js&"
import style0 from "./Framevastgoed.vue?vue&type=style&index=0&id=4d1f0d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f0d00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
